import React from "react";
import VerifiedRoundedIcon from "@mui/icons-material/VerifiedRounded";
import NewReleasesRoundedIcon from "@mui/icons-material/NewReleasesRounded";
import { IHelperTextState } from "../../CouponCodeFormGroup.interfaces";
import { helper_text_types } from "../../CouponCodeFormGroup.constants";
import styles from "./HelperTextComponent.module.scss";

export const HelperTextComponent = ({ text, type }: IHelperTextState) => {
    switch (type) {
        case helper_text_types.success:
            return (
                <>
                    <VerifiedRoundedIcon
                        fontSize="small"
                        className={styles.iconStyle}
                    />
                    &nbsp;
                    {text}
                </>
            );
        case helper_text_types.error:
            return (
                <>
                    <NewReleasesRoundedIcon
                        fontSize="small"
                        className={styles.iconStyle}
                    />
                    &nbsp;
                    {text}
                </>
            );
        case helper_text_types.empty:
        default:
            return null;
    }
};
